import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import {
  Button,
  InputGroup,
  Switch,
  Popover,
  Position,
  TextArea,
  Tooltip,
  NumericInput
} from "@blueprintjs/core";
import withEditorProps from "../withEditorProps";
import { MAX_MATCHES_DISPLAYED } from "../constants/findToolConstants";
import "./style.css";
import { InfoHelper, TgHTMLSelect } from "@teselagen/ui";
import { searchableTypes } from "../selectors/annotationSearchSelector";
import { getSingular } from "../utils/annotationTypes";
import { getFeatureToColorMap } from "@teselagen/sequence-utils";
import { getReverseComplementSequenceString } from "@teselagen/sequence-utils";
import isMobile from "is-mobile";
const opts = [
  { label: "DNA", value: "DNA" },
  { label: "Amino Acids", value: "AA" }
];
export class FindBar extends React.Component {
  componentDidMount() {
    this.possiblyNormalizeMatchNumber();
    if (this.inputEl) {
      this.inputEl.select();
    }
  }
  possiblyNormalizeMatchNumber = () => {
    const { findTool, updateMatchNumber } = this.props;
    if (findTool.matchNumber !== 0 && findTool.matchNumber >= findTool.matchesTotal) {
      updateMatchNumber(0);
    }
  };
  componentDidUpdate(prevProps) {
    this.possiblyNormalizeMatchNumber();
    const {
      findTool,
      updateMatchNumber,
      caretPosition,
      selectionLayer,
      searchLayers
    } = this.props;
    const { findTool: prevFindTool } = prevProps;
    if (searchLayers && searchLayers.length > 0 && (findTool.searchText !== prevFindTool.searchText || findTool.ambiguousOrLiteral !== prevFindTool.ambiguousOrLiteral || findTool.dnaOrAA !== prevFindTool.dnaOrAA || findTool.matchReverseComplement !== prevFindTool.matchReverseComplement || findTool.mismatchesAllowed !== prevFindTool.mismatchesAllowed)) {
      const currentPos = caretPosition > -1 ? caretPosition : selectionLayer.start > -1 ? selectionLayer.start : 0;
      let bestMatchIndex = 0;
      for (let i = 0; i < searchLayers.length; i++) {
        if (searchLayers[i].start >= currentPos) {
          bestMatchIndex = i;
          break;
        }
      }
      if (bestMatchIndex !== findTool.matchNumber) {
        updateMatchNumber(bestMatchIndex);
      }
    }
  }
  render() {
    const {
      toggleFindTool,
      toggleHighlightAll,
      toggleMatchReverseComplement,
      toggleIsInline,
      updateSearchText,
      annotationVisibilityShow,
      updateAmbiguousOrLiteral,
      updateDnaOrAA,
      updateMismatchesAllowed,
      updateMatchNumber: _updateMatchNumber,
      selectionLayerUpdate,
      caretPositionUpdate,
      annotationSearchMatches,
      findTool = {}
    } = this.props;
    const {
      searchText,
      dnaOrAA,
      highlightAll,
      matchReverseComplement,
      ambiguousOrLiteral,
      matchesTotal = 0,
      matchNumber = 0,
      mismatchesAllowed = 0,
      isInline
    } = findTool;
    const updateMatchNumber = (...args) => {
      if (matchesTotal > 1 && !(getReverseComplementSequenceString(searchText) === searchText && matchesTotal === 2)) {
        _updateMatchNumber(...args);
      } else {
        _updateMatchNumber(null);
        setTimeout(() => {
          _updateMatchNumber(...args);
        });
      }
    };
    const findOptionsEls = [
      /* @__PURE__ */ jsx(
        TgHTMLSelect,
        {
          options: opts,
          name: "dnaOrAA",
          value: dnaOrAA,
          onChange: (e) => {
            updateDnaOrAA(e.target.value);
          }
        },
        "dnaoraa"
      ),
      /* @__PURE__ */ jsxs("div", { style: { display: "flex" }, children: [
        /* @__PURE__ */ jsx(
          TgHTMLSelect,
          {
            name: "ambiguousOrLiteral",
            options: [
              { label: "Literal", value: "LITERAL" },
              { label: "Ambiguous", value: "AMBIGUOUS" }
            ],
            value: ambiguousOrLiteral,
            onChange: (e) => {
              updateAmbiguousOrLiteral(e.target.value);
            }
          }
        ),
        /* @__PURE__ */ jsx(InfoHelper, { style: { marginLeft: 10 }, children: /* @__PURE__ */ jsxs("div", { children: [
          "Ambiguous substitutions:",
          /* @__PURE__ */ jsxs("div", { style: { display: "flex", fontSize: 12 }, children: [
            /* @__PURE__ */ jsxs("div", { style: { marginRight: 20 }, children: [
              /* @__PURE__ */ jsx("div", { style: { fontSize: 14, marginBottom: 4, marginTop: 5 }, children: "DNA:" }),
              /* @__PURE__ */ jsx("div", { children: "M: AC" }),
              /* @__PURE__ */ jsx("div", { children: "R: AG" }),
              /* @__PURE__ */ jsx("div", { children: "W: AT" }),
              /* @__PURE__ */ jsx("div", { children: "S: CG" }),
              /* @__PURE__ */ jsx("div", { children: "Y: CT" }),
              /* @__PURE__ */ jsx("div", { children: "K: GT" }),
              /* @__PURE__ */ jsx("div", { children: "V: ACG" }),
              /* @__PURE__ */ jsx("div", { children: "H: ACT" }),
              /* @__PURE__ */ jsx("div", { children: "D: AGT" }),
              /* @__PURE__ */ jsx("div", { children: "B: CGT" }),
              /* @__PURE__ */ jsx("div", { children: "X: GATC" }),
              /* @__PURE__ */ jsx("div", { children: "N: GATC" }),
              /* @__PURE__ */ jsx("div", { children: "*: any" })
            ] }),
            /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx("div", { style: { fontSize: 14, marginBottom: 4, marginTop: 5 }, children: "AA:" }),
              /* @__PURE__ */ jsx("div", { children: "B: ND" }),
              /* @__PURE__ */ jsx("div", { children: "J: IL" }),
              /* @__PURE__ */ jsx("div", { children: "X: ACDEFGHIKLMNPQRSTVWY" }),
              /* @__PURE__ */ jsx("div", { children: "Z: QE" }),
              /* @__PURE__ */ jsx("div", { children: "*: any" })
            ] })
          ] })
        ] }) })
      ] }, "ambiguousorliteral"),
      /* @__PURE__ */ jsxs(
        "div",
        {
          style: { marginTop: "8px", display: "flex", alignItems: "center" },
          children: [
            /* @__PURE__ */ jsx("label", { style: { marginRight: "8px" }, children: "Mismatches Allowed:" }),
            /* @__PURE__ */ jsx(
              NumericInput,
              {
                min: 0,
                max: 10,
                className: "tg-mismatches-allowed-input",
                style: { width: "60px" },
                value: mismatchesAllowed,
                disabled: dnaOrAA !== "DNA" || ambiguousOrLiteral !== "LITERAL",
                onValueChange: (value) => {
                  const newValue = Math.max(0, parseInt(value, 10) || 0);
                  updateMismatchesAllowed(newValue);
                }
              }
            ),
            /* @__PURE__ */ jsx(InfoHelper, { style: { marginLeft: 10 }, children: /* @__PURE__ */ jsxs("div", { children: [
              "Number of mismatches allowed when searching DNA sequences with literal matching.",
              /* @__PURE__ */ jsx("br", {}),
              /* @__PURE__ */ jsx("br", {}),
              "Higher values may slow down search performance."
            ] }) })
          ]
        },
        "mismatchesAllowed"
      ),
      /* @__PURE__ */ jsx(
        Switch,
        {
          checked: matchReverseComplement,
          onChange: toggleMatchReverseComplement,
          children: "Match reverse complement"
        },
        "matchReverseComplement"
      ),
      /* @__PURE__ */ jsx(
        Switch,
        {
          checked: highlightAll,
          onChange: toggleHighlightAll,
          disabled: matchesTotal > MAX_MATCHES_DISPLAYED,
          children: /* @__PURE__ */ jsx(
            Tooltip,
            {
              disabled: matchesTotal <= MAX_MATCHES_DISPLAYED,
              content: "Disabled because there are >{MAX_MATCHES_DISPLAYED} matches",
              children: "Highlight All"
            }
          )
        },
        "highlightall"
      ),
      ...isMobile() ? [] : [
        /* @__PURE__ */ jsx(
          Switch,
          {
            checked: !isInline,
            onChange: toggleIsInline,
            children: "Expanded"
          },
          "isInline"
        )
      ]
    ];
    const InputToUse = !isInline ? TextArea : InputGroup;
    const rightEl = /* @__PURE__ */ jsxs("span", { children: [
      isInline && /* @__PURE__ */ jsx(
        Popover,
        {
          autoFocus: false,
          enforceFocus: false,
          position: Position.BOTTOM,
          target: /* @__PURE__ */ jsx(
            Button,
            {
              "data-test": "veFindBarOptionsToggle",
              minimal: true,
              icon: "wrench"
            }
          ),
          content: /* @__PURE__ */ jsx(
            "div",
            {
              className: "ve-find-options-popover",
              style: {
                display: "flex",
                flexDirection: "column",
                paddingLeft: 20,
                paddingBottom: 10,
                paddingTop: 10,
                paddingRight: 20
              },
              children: findOptionsEls
            }
          )
        }
      ),
      /* @__PURE__ */ jsxs("span", { style: { marginRight: 3, color: "lightgrey" }, children: [
        matchesTotal > 0 ? matchNumber + 1 : 0,
        "/",
        matchesTotal
      ] }),
      /* @__PURE__ */ jsx(
        Button,
        {
          "data-test": "veFindPreviousMatchButton",
          minimal: true,
          small: true,
          disabled: matchesTotal <= 0,
          onClick: () => {
            updateMatchNumber(
              matchesTotal <= 0 ? 0 : mod(matchNumber - 1, matchesTotal)
            );
          },
          icon: "caret-up"
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          "data-test": "veFindNextMatchButton",
          minimal: true,
          small: true,
          disabled: matchesTotal <= 0,
          onClick: () => {
            updateMatchNumber(
              matchesTotal <= 0 ? 0 : mod(matchNumber + 1, matchesTotal)
            );
          },
          icon: "caret-down"
        }
      ),
      isInline && /* @__PURE__ */ jsx(Button, { minimal: true, small: true, onClick: toggleFindTool, icon: "small-cross" })
    ] });
    return /* @__PURE__ */ jsxs(
      "div",
      {
        style: isInline ? {
          display: "flex",
          minWidth: 300
        } : {
          position: "relative",
          top: 100,
          padding: 10,
          display: "flex",
          alignItems: "start",
          paddingBottom: 5,
          zIndex: 2e4
        },
        className: "veFindBar",
        children: [
          /* @__PURE__ */ jsx(
            Popover,
            {
              autoFocus: false,
              enforceFocus: false,
              target: /* @__PURE__ */ jsx(
                InputToUse,
                {
                  autoFocus: true,
                  style: {
                    resize: "vertical",
                    ...!isInline && {
                      width: 350,
                      height: 190
                    }
                  },
                  className: "tg-find-tool-input",
                  inputRef: (n) => {
                    if (n) this.inputEl = n;
                  },
                  onKeyDown: (e) => {
                    e.persist();
                    if (e.metaKey && e.keyCode === 70) {
                      e.preventDefault();
                      e.stopPropagation();
                    } else if (e.keyCode === 13) {
                      updateMatchNumber(
                        matchesTotal <= 0 ? 0 : mod(matchNumber + 1, matchesTotal)
                      );
                      e.stopPropagation();
                      e.preventDefault();
                    } else if (e.keyCode === 27) {
                      selectionLayerUpdate({ start: -1, end: -1 });
                      caretPositionUpdate(-1);
                      toggleFindTool();
                    }
                  },
                  ...isInline && { rightElement: rightEl, leftIcon: "search" },
                  onChange: (e) => {
                    const text = e.target.value.replace(/\s/g, "");
                    if (/[efilpqjoz]/i.test(text) && dnaOrAA === "DNA") {
                      updateDnaOrAA("AA");
                    }
                    return updateSearchText(text);
                  },
                  value: searchText
                }
              ),
              position: "bottom",
              minimal: true,
              isOpen: annotationSearchMatches && annotationSearchMatches.filter((m) => m.length).length,
              content: /* @__PURE__ */ jsx(
                AnnotationSearchMatchComp,
                {
                  annotationVisibilityShow,
                  toggleFindTool,
                  selectionLayerUpdate,
                  annotationSearchMatches
                }
              )
            }
          ),
          !isInline && /* @__PURE__ */ jsxs(
            "div",
            {
              style: {
                marginLeft: 10,
                display: "flex",
                flexDirection: "column",
                gap: 5
              },
              children: [
                rightEl,
                findOptionsEls
              ]
            }
          ),
          !isInline && /* @__PURE__ */ jsx(
            Button,
            {
              minimal: true,
              style: { position: "absolute", bottom: 0, right: 0 },
              onClick: toggleFindTool,
              icon: "cross"
            }
          )
        ]
      }
    );
  }
}
export default withEditorProps(FindBar);
function mod(n, m) {
  return (n % m + m) % m;
}
function AnnotationSearchMatchComp({
  annotationSearchMatches,
  selectionLayerUpdate,
  annotationVisibilityShow,
  toggleFindTool
}) {
  const toReturn = /* @__PURE__ */ jsx("div", { className: "veAnnotationFindMatches", children: searchableTypes.map((type, i) => {
    const annotationsFound = annotationSearchMatches[i];
    if (!annotationsFound) return null;
    return annotationsFound.length ? /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsxs("div", { className: "veAnnotationFoundType", children: [
        annotationsFound.length,
        " ",
        getSingular(type),
        " match",
        annotationsFound.length > 1 ? "es" : null,
        annotationsFound.length <= 10 ? null : ` (only showing 10)`,
        ":"
      ] }),
      /* @__PURE__ */ jsx("div", { children: annotationsFound.slice(0, 10).map((ann, i2) => {
        return /* @__PURE__ */ jsxs(
          "div",
          {
            onClick: () => {
              annotationVisibilityShow(type);
              selectionLayerUpdate(ann);
              toggleFindTool();
            },
            className: "veAnnotationFoundResult",
            children: [
              /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center" }, children: [
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    style: {
                      background: type === "parts" ? "#ac68cc" : ann.color || getFeatureToColorMap({ includeHidden: true })[ann.type],
                      height: 15,
                      width: 15,
                      marginRight: 3
                    }
                  }
                ),
                ann.name
              ] }),
              /* @__PURE__ */ jsxs("div", { className: "veAnnotationFoundResultRange", children: [
                ann.start + 1,
                "-",
                ann.end + 1
              ] })
            ]
          },
          i2
        );
      }) })
    ] }, i) : null;
  }) });
  return toReturn;
}
